export * as capitalRoutes from "./capital"
export * as dashboardRoutes from "./dashboard"
export * as standaloneRoutes from "./standalone"
export * as reportsRoutes from "./reports"

/**
 * Map of routes
 * Keys are MF names
 * Values are arrays of corresponding top-level routes
 * Should be used both for shell and (in the future) for infra
 */
export const topLevelRoutes = {
  "@zettle-bo/integrations": ["/apps", "/apps/*"],
  "@zettle-bo/capital": ["/capital", "/capital/*"],
  "@zettle-bo/customers": ["/customers", "/customers/*"],
  "@zettle-bo/gift-cards": ["/gift-cards", "/gift-cards/*"],
  "@zettle-bo/dashboard": ["/dashboard", "/dashboard/*", "/"],
  "@zettle-bo/direct-debit": ["/direct-debit", "/direct-debit/*"],
  "@zettle-bo/products": [
    "/products",
    "/products/*",
    "/categories",
    "/pages",
    "/pages/*",
    "/settings/products/tax",
  ],
  "@zettle-bo/reports": ["/reports-v2", "/reports-v2/*"],
  "@zettle-bo/settings": ["/settings"],
  "@zettle-bo/account-settings": [
    "/settings/account",
    "/settings/email_addresses/:hash/confirm",
    "/settings/confirm-email-address",
  ],
  "@zettle-bo/bank-settings": ["/settings/bank-account-v2"],
  "@zettle-bo/receipts": ["/settings/receipt"],
  "@zettle-bo/cash-register": ["/cash-register", "/cash-register/*"],
  "@zettle-bo/standalone-pages": ["/standalone/*"],
  "@zettle-bo/inventory": ["/inventory-v2"],
  "@zettle-bo/sales-trends": ["/sales-trends"],
  "@zettle-bo/invoices": ["/invoices-v2", "/invoices-v2/*"],
  "@zettle-bo/account-statement": ["/statement-v2"],
  "@zettle-bo/staff-account": ["/settings/staff", "/staff-v2"],
}
